<template>
  <div
    class="heat-map-widget"
    :style="style"
  >
    <div
      v-for="(row, index1) in scaledValues"
      :key="index1"
      class="heat-row"
    >
      <div
        v-for="(value, index2) in row"
        :key="index2"
        class="rect"
        :style="{ backgroundColor: colors[value - 1] }"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'HeatMapWidgetView',
  components: {
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.widget.height}px`,
        width: `${this.widget.width}px`,
        zIndex: this.widget.zIndex,
        transform: `rotate(${this.widget.rotate}deg)`,
        background: this.widget.background,
        borderRadius: this.widget.borderRadius,
        padding: this.widget.padding,
      };
    },
    data() {
      try {
        const data = JSON.parse(this.widget.data);
        const convertedData = this.transformData(data);
        if (!_.isArray(convertedData)) {
          return [];
        }
        return convertedData.filter(row => _.isArray(row));
      } catch (e) {
        return [];
      }
    },
    scaledValues() {
      const max = Math.max(..._.flatten(this.data), 1); // If all values are 0, we will use 1 as the maximum
      // To make 0 value also visible, if the value will be 0, I will return 1
      return this.data.map(row => row.map(value => Math.max(Math.ceil((value / max) * this.colors.length), 1)));
    },
    colors() {
      return [
        '#fbe9e7',
        '#ffccbc',
        '#ffab91',
        '#ff8a65',
        '#ff7043',
        '#f4511e',
      ];
    },
  },
  methods: {
    transformData(data) {
      const groupedRows = _.chain(data)
        .groupBy(d => d.rowIndex)
        .mapValues(row => _.sortBy(row, item => item.colIndex).map(item => item.val))
        .value();

      return _.chain(groupedRows)
        .keys()
        .sortBy(rowIndex => parseInt(rowIndex, 10))
        .map(rowIndex => groupedRows[rowIndex])
        .value();
    },
  },
};
</script>

<style lang="scss" scoped>
.heat-map-widget {
  position: absolute;
  display: flex;
  flex-direction: column;
  direction: ltr;
  .heat-row {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0;
    }
    .rect {
      width: 8px;
      height: 20px;
      border-radius: 5px;
      margin-left: 2px;
    }
  }
}
</style>
